import { Component, OnInit } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Bidding, BiddingStatus } from '../../model/bidding';
import { Company } from '../../model/company';

@Component({
  selector: 'app-budget-report',
  templateUrl: './budget-report.component.html',
  styleUrls: ['./budget-report.component.css'],
  providers: [DBService]
})
export class BudgetReportComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  initialDate: number;
  initialDateString: string;

  endDate: number;
  endDateString: string;

  companyFilter: string;

  companies: Company[];
  biddings: Bidding[];
  displayBiddings: Bidding[];

  loading: boolean;

  emptyData: boolean;

  earnedCount: number;
  lostCount: number;
  waitingCount: number;
  refusedCount: number;
  inProgressCount: number;

  totalCount: number;
  effectiveCount: number;

  earnedAmount: number;
  lostAmount: number;

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartType = 'bar';
  public barChartLegend = true;

  public barChartData: any[] = [
    {data: [65], label: 'Valor médio do orçamento do cliente (R$)'},
    {data: [28], label: 'Valor médio ganho da licitação (R$)'}
  ];

  public pieChartColors: Array<any> =
  [
    { backgroundColor: ['#3f51b5', '#3f51b5']},
    { backgroundColor: ['#4CAF50', '#F44336']},
    { backgroundColor: ['#fff', '#fff']}
  ];

  constructor(private dbService: DBService) {
    this.endDateString = '';
    this.initialDateString = '';
    this.companyFilter = '0';
    this.emptyData = true;
    this.loadCompanies();
    this.loadActivities();
  }

  ngOnInit() {
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => this.companies = companies);
  }

  private loadActivities() {
    this.dbService.listWithUIDs<Bidding>('biddings')
      .then(biddings => this.biddings = biddings.filter(b => b.status == BiddingStatus.EARNED));
  }

  search() {
    this.emptyData = false;

    this.displayBiddings = this.biddings
      .filter(a => a.biddingDate >= this.initialDate)
      .filter(a => a.biddingDate <= this.endDate);

    if (this.companyFilter != '' && this.companyFilter != '0') {
      this.displayBiddings = this.displayBiddings.filter(a => a.companyUID == this.companyFilter);
    }

    if (this.displayBiddings.length === 0) {
      this.initEmptyData();
    } else {
      this.initData();
    }
  }

  private initEmptyData() {
    this.barChartData = [
      {data: [0], label: 'Valor médio do orçamento do cliente (R$)'},
      {data: [0], label: 'Valor médio ganho da licitação (R$)'}
    ];

    this.loading = false;
  }

  private initData() {
    this.loading = true;

    const budgetSum = this.displayBiddings
      .map(b => Math.round((b.earningPrice / b.companyMaximumPrice) * 100))
      .reduce((v1, v2) => v1 + v2, 0);
    const budgetAVG = budgetSum / this.displayBiddings.length;

    this.barChartData = [
      {data: [100], label: 'Orçamento do cliente (%)'},
      {data: [budgetAVG], label: 'Valor ganho da licitação (% do orçamento)'},
      {data: [0], label: ''},
    ];

    this.loading = false;
  }

  onChangeStartDate(event) {
    const dateParts = this.initialDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.initialDate;
    } else {
      this.initialDate = date.getTime();
    }
  }

  onChangeEndDate(event) {
    const dateParts = this.endDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.endDate;
    } else {
      this.endDate = date.getTime();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/budget-report/budget-report.component.ts